module.exports = __webpack_public_path__ + "img/txt.8f786aa6.svg";